import { Box, Text, Flex, Heading, HStack, VStack, Stack, Image } from "@chakra-ui/react"
import { motion, Variants } from "framer-motion"

export const AboutPage = () => {
    const container: Variants = {
        hidden: {
            y: 300,
            opacity: 0
        },
        show: {
            opacity: 1,
            y: 0,
            transition: {
                type: "spring",
                bounce: 0.4,
                duration: 0.8,
                delayChildren: 0.3,
                staggerChildren: 0.2
            }
        }
    };

    const items: Variants = {
        hidden: {
            y: 25,
            opacity: 0
        },
        show: {
            opacity: 1,
            y: 0,
        }
    }

    return (
        <motion.div id="ABOUT" variants={container} whileInView="show" initial="hidden" viewport={{ once: true }}>
            <Flex pt="7rem" width="100%" bg="background" direction="column" justifyContent="center">
                <VStack
                    // height="70%"
                    bg="container_bg"
                    p="2rem" pt="2rem" pb="1.5rem" borderRadius="20px" margin="1rem auto" width="90%"
                    border="solid 0.5px var(--chakra-colors-container_outline)"
                    boxShadow="0px 0px 8px 0px var(--chakra-colors-container_shadow)"
                    alignItems="start">
                    <Stack spacing="1rem" maxWidth="100%" direction={["column", null, null, "row"]} >
                        <Flex as={motion.div} variants={items}  alignSelf="center" width="fit-content" bg="container_bg_alt" rounded="10px" padding="1rem" justifyContent='center'>
                            <Image minWidth="15rem" rounded="5px" boxShadow="0px 0px 2px 0px #00000020" src={"ahmed-portrait.jpg"} />
                        </Flex>
                        <VStack alignItems="left" maxWidth={["100%", null, null, "50%"]} textAlign="left" px="1rem">
                            <Box as={motion.div} variants={items} mb="1.5rem">
                                <Heading variant="special" as="span">ABOUT</Heading>
                                <Heading variant="special" as="span" color="#FF9820" >.</Heading>
                            </Box>
                            <Heading as={motion.div} variants={items} variant="subheading">About Me</Heading>
                            <Text as={motion.div} variants={items} variant="body">Hello! I’m Ahmed Imana, a passionate freelance web developer with a love for creative innovative solutions and telling compelling stories through my work.
                            </Text>

                            <Heading as={motion.div} variants={items} variant="subheading">My Journey</Heading>
                            <Text as={motion.div} variants={items} variant="body" >From a young age, I’ve always been fascinated by technology and design. Through this curiosity, I’ve been led to pursue further learning and honed my skills in web design and development.

                                <br /><br />Over the years, I’ve had the privilege of working on personal projects, ranging from finance applications to study tools, all with responsive web design principles. Each experience has enriched my skills and fueled my passion for front-end development.
                            </Text>
                            <Box as={motion.div} variants={items} my="1.5rem">
                                <Heading variant="special" as="span">SKILLS</Heading>
                                <Heading variant="special" as="span" color="#FF9820" >.</Heading>
                            </Box>
                            <HStack as={motion.div} variants={items} bg="container_bg_alt" rounded="10px" width="100%" overflowX="scroll" padding="1rem" whiteSpace="nowrap">
                                <Text variant="tag">React</Text>
                                <Text variant="tag">Chakra UI</Text>
                                <Text variant="tag">HTML</Text>
                                <Text variant="tag">CSS</Text>
                                <Text variant="tag">Javascript</Text>
                                <Text variant="tag">NodeJS</Text>
                                <Text variant="tag">Python</Text>
                            </HStack>
                        </VStack>

                    </Stack>
                </VStack>
            </Flex>


        </motion.div>
    )
}